export default __webpack_public_path__ + "static/media/telephone.df5f4615.svg";